export enum RegisterFormFields {
  email = 'email',
  password = 'password',
  phone = 'phone',
  gdpr = 'gdpr',
  consent = 'consent',
}

export interface RegisterFormValues {
  readonly [RegisterFormFields.email]: string
  readonly [RegisterFormFields.password]: string
  readonly [RegisterFormFields.gdpr]: boolean
  readonly [RegisterFormFields.phone]?: string
  readonly [RegisterFormFields.consent]?: boolean
}
